<div class="row no-padding responsive">
  <div class="col">
    <a routerLink="/sustain" aria-label="Scopri come sostenere Just Play Bologna">
      <img src="assets/SostegnoAd.jpg" alt="Banner: sostieni Just Play Bologna">
    </a>
  </div>
</div>

<div class="row no-padding div-custom-link">
  <div class="col">
    <a class="custom-link" routerLink="/support"><b>Scopri qui come</b></a>
  </div>
</div>
<div class="row no-padding div-custom-link">
  <div class="col">
    <a class="custom-link" routerLink="/home">Home</a>
  </div>
</div>
